module.exports = __webpack_public_path__ + "img/unavailable_scanning.8fba0039.svg";